import ActivityStatus from '../../../../../enums/activities/ActivityStatus.ts';

/**
 * Checks if the activity status allows editing of static coding values in reconciliation.
 * Static coding can be edited when activity is in Pre-Reconciliation or Issue-Reconciliation status.
 *
 * @param activityStatus - The current activity status
 * @returns true if static coding can be edited, false otherwise
 */
export const isPreRecOrIssueRecStatus = (activityStatus: ActivityStatus | undefined): boolean => {
  return activityStatus === ActivityStatus.PreReconciliation || activityStatus === ActivityStatus.IssueReconciliation;
};
